/**
 * @file
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeSurveyPages() {
   // --------------------------------------------------------------------------
   // initialize the validation engine
   // --------------------------------------------------------------------------
   var onSubmit = false;
   customValidationInit(onSubmit);
   aspControlValidationInit();

   $(".sRating").keypress(function (event) {
      if (event.which == 13) {
         $(this).prev().click();
      }
   });
};
